import {PayersRecipientsModuleDefaults, PayersRecipientsModuleSettings} from "../models/modules";

export interface AdsUniverseModuleSettings extends PayersRecipientsModuleSettings {}

export const defaultAdsUniverseModuleSettings: AdsUniverseModuleSettings = {
  ...PayersRecipientsModuleDefaults,
}
